import { useMemo } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import ChartOption from "../types/instance/ChartOption";
import { highchartsCredits } from "../helpers/utils";
import { useLicences } from "../context/LicenceContext";

type BarChartProps = {
  uniqueIndex: number;
  chartOption: ChartOption;
  title?: string;
};

function BarChart({ uniqueIndex, chartOption, title }: BarChartProps) {
  const { licences } = useLicences();

  const chartOptions = useMemo(() => {
    // Sort by count descending and take top 10
    const sortedData = [...chartOption.data]
      .sort((a, b) => b.y - a.y)
      .slice(0, 10);

    return {
      chart: {
        type: "bar",
        height: "300px",
        style: {
          fontFamily: "system-ui, Arial, sans-serif",
          fontSize: "1rem",
          letterSpacing: "normal"
        }
      },
      title: { text: "" },
      xAxis: {
        categories: sortedData.map((d: any) => d.name),
        title: { text: null }
      },
      yAxis: {
        min: 0,
        title: { text: null },
        labels: { overflow: "justify" }
      },
      tooltip: {
        valueSuffix: "",
        formatter: function (): any {
          // @ts-ignore
          return `<b>${this.x}</b>: ${this.point.y}`;
        }
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            format: "{point.y}"
          }
        }
      },
      legend: { enabled: false },
      credits: { enabled: highchartsCredits(licences) },
      exporting: { enabled: false },
      series: [
        {
          name: chartOption.key,
          data: sortedData.map((d: any) => ({
            y: d.y,
            color: d.color,
            name: d.name
          }))
        }
      ]
    };
  }, [chartOption, licences]);

  return (
    <div className="col">
      <div className="card collapsible">
        <div className="card-header">
          <i className="fal fa-chart-bar fa-fw" aria-hidden="true"></i>
          {title ? title : `Top ${chartOption.key.toLowerCase()}`}
          <i className="collapse-toggle" role="button" data-bs-toggle="collapse"
             data-bs-target=".multi-collapse-pie" aria-expanded="false" aria-controls=""></i>
        </div>
        <div id={`collapseChart${uniqueIndex}`} className="card-body collapse show multi-collapse-pie">
          <HighchartsReact constructorType={"chart"} highcharts={Highcharts} options={chartOptions} />
        </div>
      </div>
    </div>
  );
}

export default BarChart;
